mutation ContactsCreateFromEmailSync($input: [ContactsCreateFromEmailSyncInput!]!) {
    contactsCreateFromEmailSync(input: $input) {
        id
        name
    }
}
